<template>
	<div class="inteDet">
		<div class="breadcrumb">奖品详情
			<el-button class="right_f" type="primary" @click="cancel">取消</el-button>
		</div>

		<div class="detail">
			<el-form ref="inteForm" :model="inteForm" label-width="140px">
				<el-form-item label="奖品名称：" required>
					<el-input v-model="inteForm.prizeName" placeholder="奖品名称" class="inputTitle" disabled></el-input>
				</el-form-item>
				<el-form-item label="奖品图片：" required>
					<img :src="inteForm.imgUrl" style="width:200px;display:inline-block;">
					<br>
					<span class="gray">（尺寸说明：360×300像素，jpg、jpeg、png）</span>
				</el-form-item>
				<el-form-item label="中奖概率：" required>
					<el-input v-model.number="inteForm.probability" class="probability" disabled style="width: 250px;">
						<template slot="append" style="line-height: 34px;">%</template>
					</el-input>
					<span style="color:red;">（可配置的最低中奖概率为0.01%）</span>
				</el-form-item>

				<el-form-item label="自动兑奖:" required>
					<el-radio v-model="inteForm.isAuto" label="1" disabled>是</el-radio>
					<el-radio v-model="inteForm.isAuto" label="0" class="inline" disabled>否</el-radio>
				</el-form-item>

				<el-form-item label="是否无限:" required>
					<el-radio v-model="inteForm.isInfinite" label="1" disabled>是</el-radio>
					<el-radio v-model="inteForm.isInfinite" label="0" class="inline" disabled>否</el-radio>
				</el-form-item>

				<el-form-item label="可中奖次数:" required>
					<el-radio v-model="inteForm.isLimit" label="0" disabled>不限</el-radio>
					<el-radio v-model="inteForm.isLimit" label="1" class="inline" disabled>限定</el-radio>
					<br>
					<el-input v-model="inteForm.drawHitCount" v-if='inteForm.isLimit=="1"' placeholder="请输入自定义数量" style="width: 250px;" class="probability"
					 disabled>
						<template slot="append" style="line-height: 34px;">次</template>
					</el-input>
				</el-form-item>

				<el-form-item label="兑奖URL:" required>
					<el-radio v-model="inteForm.definePrizeUrl" label="false" disabled>不跳转</el-radio>
					<br>
					<el-radio v-model="inteForm.definePrizeUrl" label="true" class="inline" disabled>自定义URL</el-radio>
					<br>
					<el-input v-model="inteForm.prizeUrl" v-if='inteForm.definePrizeUrl=="true"' class="inputTitle" disabled></el-input>
				</el-form-item>

				<el-form-item class="time" label="兑换开始时间：" required>
					<el-date-picker v-model="inteForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
				</el-form-item>

				<el-form-item class="time" label="兑换结束时间：" required>
					<el-date-picker v-model="inteForm.endTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
				</el-form-item>

				<el-form-item label="广告曝光代码:" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" disabled v-model="inteForm.adExposingCodes">
					</el-input>
				</el-form-item>

				<el-form-item label="文案类型：" class="prizeContent" required>
					<el-radio v-model="inteForm.isRedeem" label="1" disabled>兑奖码类型</el-radio>
					<el-radio v-model="inteForm.isRedeem" label="0" class="inline" disabled>自定义文案</el-radio>
				</el-form-item>

				<el-form-item label="文案：" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" disabled v-model="inteForm.defineText">
					</el-input>
				</el-form-item>
			</el-form>

		</div>

	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";

	export default {
		data() {
			return {
				position: this.$util.getUrlParam("position"),
				dataList: {},
				inteForm: {}
			};
		},
		mounted() {
			this.dataList = JSON.parse(this.$util.getStore("prizeList"));
			//根据position获取奖品详情

			this.getDetail();
		},
		methods: {
			cancel() {
				location.href = "/#/yunying/integration/integration?isFirst=1";
			},
			//获取奖品详情
			getDetail() {
				this.dataList.forEach(item => {
					if (this.position == item.position) {
						this.inteForm = {
							id: item.id,
							position: item.position,
							prizeName: item.prizeName,
							probability: item.probability / 100,
							imgUrl: item.imgUrl,
							drawHitCount: item.drawHitCount,
							isLimit: item.drawHitCount == -1 ? "0" : "1",
							prizeUrl: item.prizeUrl,
							fileUrl: item.fileUrl,
							adExposingCodes: item.adExposingCodes,
							isRedeem: item.isRedeem + "",
							defineText: item.isRedeem == 1 ? item.redeemText : item.defineText,
							startTime: item.startTime,
							endTime: item.endTime,
							isAuto: item.isAuto + "",
							isInfinite: item.isInfinite + "",
							definePrizeUrl: item.definePrizeUrl + ""
						};
					}
				});
			}
		}
	};
</script>

<style>
	.inputTitle {
		width: 40%;
	}

	.qizhiDate {
		display: inline-block;
		width: 100%;
	}

	.inteDet .time {
		width: 40%;
	}

	.inteDet .campContain {
		width: 700px;
		height: 135px;
		border: solid 1px gray;
		box-sizing: border-box;
		overflow-y: scroll;
	}

	.inteDet .irregular {
		display: inline-block;
	}

	.inteDet .campSpan {
		display: block;
		text-align: center;
		float: left;
		height: 36px;
		padding: 0 30px 5px 15px;
		border: solid 1px #999;
		border-radius: 5px;
		margin: 10px;
		box-sizing: border-box;
		font-size: 12px;
		position: relative;
		cursor: pointer;
	}

	.gray {
		color: #999;
	}

	.campSpan i {
		width: 20px;
		height: 20px;
		line-height: 20px;
		color: #999;
		position: absolute;
		right: 5px;
		top: 5px;
	}

	.probability .el-input__inner {
		height: 38px;
	}

	.inteDet .el-input-group__append {
		line-height: 34px;
		height: 34px;
	}

	.inteDet .el-radio__inner.is-disabled.is-checked {
		background-color: black;
		border-color: black;
	}
</style>


// WEBPACK FOOTER //
// integrationDet.vue?3c9657bd